module.exports = __webpack_public_path__ + "static/media/IDP_active.aa85318f.svg";